export const AUTHENTICATION = 'authentication';
export const BILLING = 'billing';
export const BUDGET_MANAGEMENT = 'budget_management';
export const CONCIERGE = 'concierge';
export const HOME = 'home';
export const INSIGHTS = 'insights';
export const PEOPLE = 'people';
export const PROGRAMS = 'programs';
export const TRAVEL_PROGRAM = 'travel_program';

export const modules = [
	AUTHENTICATION,
	BILLING,
	BUDGET_MANAGEMENT,
	CONCIERGE,
	HOME,
	INSIGHTS,
	PEOPLE,
	PROGRAMS,
	TRAVEL_PROGRAM,
];

export default {
	AUTHENTICATION,
	BILLING,
	BUDGET_MANAGEMENT,
	CONCIERGE,
	HOME,
	INSIGHTS,
	PEOPLE,
	PROGRAMS,
	TRAVEL_PROGRAM,
};
